import { Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { SEARCH_TEMPLATE_QUESTION } from 'queries/question'
import { searchTemplateQuestion, searchTemplateQuestionVariables } from '__generatedTypes__/searchTemplateQuestion'
import { searchQuestionCategory_searchQuestionCategory_items as QuestionCategory } from '__generatedTypes__/searchQuestionCategory'

export type TemplateFilters = {
  questionCategory: QuestionCategory
}

export function castParams({ page, take, search, filters }: Params<TemplateFilters>): searchTemplateQuestionVariables {
  return {
    searchString: search,
    skip: (page - 1) * take,
    take,
    questionCategoryId: filters.questionCategory ? filters.questionCategory.id : undefined,
  }
}

export function useQuestionTemplates(initialFilters?: Partial<TemplateFilters>) {
  return useQueryWithParams<
    searchTemplateQuestion,
    searchTemplateQuestionVariables,
    'searchTemplateQuestion',
    'items',
    'count',
    TemplateFilters
  >(
    SEARCH_TEMPLATE_QUESTION,
    'searchTemplateQuestion',
    'items',
    'count',
    castParams,
    undefined,
    {
      fetchPolicy: 'network-only',
    },
    initialFilters ? { filters: initialFilters } : undefined
  )
}
